export const VocabProCalendarEventDetailModal = {
    'phone_number': ['Numero telefonico', 'Phone Number'],
    'start': ['Inicio', 'Start'],
    'end': ['Final', 'End'],
    'processing_request': ['Procesando peticion', 'Processing request...'],

    'cancel_appointment': ['Cancelar cita', 'Cancel Appointment '],
    'canceling': ['Cancelando...', 'Caneling...'],
    'already_cancelled': ['Ya cancelada', 'Already cancelled'],
    'save_changes': ['Guardar cambios', 'Save changes '],
    'saving': ['Guardando...', 'Saving... '],
    
    '': ['', ''],
  }